/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { SpendRule, SpendRule$inboundSchema } from "./spendrule.js";

export type ListSpendRulesResult = {
  /**
   * The list of budget rules.
   */
  rules: Array<SpendRule>;
};

/** @internal */
export const ListSpendRulesResult$inboundSchema: z.ZodMiniType<
  ListSpendRulesResult,
  unknown
> = z.object({
  rules: z.array(SpendRule$inboundSchema),
});

export function listSpendRulesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSpendRulesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSpendRulesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSpendRulesResult' from JSON`,
  );
}
